<template>
  <div>
		<div class="pageContainer">
			<div class="textHeader">租赁服务协议</div>
			<div class="textContent">
				欢迎您使用”武汉飞游云创新科技有限公司”提供的产品和服务。请您仔细阅读并理解本协议。您自愿点选“同意”键，即视为已完全同意并接受本协议，并愿受其约束；您若不同意本协议的任何条款，请不要点选“同意”，同时也无权使用”武汉飞游云创新科技有限公司”的产品和服务。您应承诺享有履行本协议的资格和能力；如您是未成年人，您还应要求您的监护人仔细阅读本协议，并取得他/他们的同意。
			</div>
			<div class="textContent">
				您受本协议以及”武汉飞游云创新科技有限公司”的产品和服务相关协议的约束，并且”武汉飞游云创新科技有限公司”有权在不另行通知的情况下，随时对本协议或相关协议进行修改，修改部分即时生效并适用。请您在使用产品和服务时进行关注并遵守，如您不同意修改，您可以随时停止使用；如果您继续使用，则视为您已经接受修改后的协议。
			</div>
			<div class="textContent">
				除非另有明确规定，”武汉飞游云创新科技有限公司”所推出的新产品、新功能和新服务，均无条件的适用本协议。用户无论通过何种方式使用”武汉飞游云创新科技有限公司”提供的上述内容服务，均受本协议约束。
			</div>
			<div class="subTitle">一、定义</div>
			<div class="textContent">
				1.1、公司：指武汉飞游云创新科技有限公司和现在或将来与该公司构成“一方有能力直接或间接控制、共同控制另一方或对另一方施加重大影响，以及两方或多方以上同受一方控制、共同控制或重大影响的关系的企业”。{{n}}
				1.2、产品和服务：指由”武汉飞游云创新科技有限公司”所有、控制和运营的，有权在各个平台出租、收益的无人机产品及其相关设备，并为各个租户提供安全全面贴心的租赁服务。
			</div>
			<div class="subTitle">二、产品的租赁和使用</div>
			<div class="textContent">
				2.1、您可以通过支付宝、微信支付等方式在我公司指定的租赁平台承租我方产品以及享受我方服务。如果您按”武汉飞游云创新科技有限公司”指定租赁平台要求提交信息和资料，并满足租赁条件，我司将以您实际下单的信息为您提供能正常安全使用的产品。在租赁期间您对该产品享有排他的使用权，并有权随时与我司人工服务了解产品相关的使用说明和具体参数。同时，您有义务保证按照合法合理的使用方式使用我方提供的产品，并对自己在租赁期间使用产品的行为承担全部的法律责任，您对所提供的信息承担相应法律责任。{{n}}
				2.2、您所租赁的产品所有权归属”武汉飞游云创新科技有限公司”，您拥有使用权，我司当设备的自然故障提供更换或维修的服务。该租赁产品不可转让、不可借用或租用、不可赠与、不可继承。您不得违反本协议约定将您租赁的产品用于本协议约定以外的其他非法目的。否则，”武汉飞游云创新科技有限公司”有权随时中止或终止向您提供本协议项下的服务以及收回产品。{{n}}
				2.3、我司保证租赁的产品向您交付的产品设备运行正常且保证与您实际下单标注的产品具有一致性。您应对您租赁期间使用产品发生的一切活动承担全部法律责任，无论该活动是由您本人进行，还是由您授权的第三方实行的，您均应承担相应的直接责任或连带责任。{{n}}
				2.4、您所下单的凭证是您使用本协议项下产品及服务的唯一凭证。您应妥善保管、正确和安全地使用。因您保密措施不当或您的其他行为，致使上述凭证丢失或泄漏所引起的一切损失和后果，均由您自行承担。{{n}}
				2.5、如租赁的产品发生其他任何问题，您有义务及时通知”武汉飞游云创新科技有限公司”包括但不限于提供您的身份信息和相关身份资料、相关事实情况及您的要求等。”武汉飞游云创新科技有限公司”收到您的有效请求并核实身份后，会根据不同情况采取相应措施。若您提供的信息不完全或不真实，导致”武汉飞游云创新科技有限公司”无法核实您的身份或无法判断您的需求，而导致”武汉飞游云创新科技有限公司”无法进行及时处理，给您造成的损失，您应自行承担。同时，”武汉飞游云创新科技有限公司”对您的请求采取措施需要合理期限，对于您通知”武汉飞游云创新科技有限公司”以及”武汉飞游云创新科技有限公司”根据您的有效通知采取措施之前，由于他人行为给您造成的损失，”武汉飞游云创新科技有限公司”不承担任何责任。{{n}}
				2.6、您在租用设备下单前应当向平台及商家提供自己的身份证原件扫描件并通过人脸识别系统确认，同时还应当提供租赁设备准确的邮寄送达地址及联系方式（包括但不限于手机号码、微信号、QQ及邮箱等）。乙方提供的身份证地址与邮寄送达地址不一致的，以乙方确认的下单页或发货时确认的邮寄送达地址为准。在租赁期限内，乙方地址及联系方式变更时应及时通知甲方和商家，否则由此导致租赁设备无法送达或丢失、电话信息失联等一切损失均由乙方承担。{{n}}
				2.7、在合理怀疑或有证据证明，因您的作为或不作为而可能损害”武汉飞游云创新科技有限公司”或任意第三方的合法权益的情况下，”武汉飞游云创新科技有限公司”有权拒绝提供服务，有权不经事先通知，而中止或终止您对产品和服务的享用，对此”武汉飞游云创新科技有限公司”不承担任何责任。
			</div>
			<div class="subTitle">三、一般使用规则</div>
			<div class="textContent">
				3.1、您保证具备履行本协议项下义务和享有本协议项下权益的资格和能力。您声明并保证尊重”武汉飞游云创新科技有限公司”和其他用户的合法权益，不贬低”武汉飞游云创新科技有限公司”的商誉以及产品和服务的声誉。{{n}}
				3.2、您声明并保证在使用”武汉飞游云创新科技有限公司”的产品和服务时不会违反任何法律、法规、条例或规章 (包括但不限于关于规范互联网站、互联网信息、不正当竞争的法律、法规、条例或规章)
				或危害他人安全、损害第三方合法权益之行为。{{n}}
				3.3、根据本协议的条款和条件，”武汉飞游云创新科技有限公司”授予您有限的、可终止的和不可转授权的使用”武汉飞游云创新科技有限公司”的产品和服务的权利。这意味着您可以自主选择安装、使用及停止使用”武汉飞游云创新科技有限公司”的产品和服务。{{n}}
				3.4、您声明并保证不会改变或者拆修”武汉飞游云创新科技有限公司”的产品中包含的任何零部件或者机身；不会以任何方式干扰或企图干扰”武汉飞游云创新科技有限公司”对其产品和服务的监管；不以任何形式非法干扰产品的正常运行，或者制作、发布、传播可能造成前述后果的工具、方法等。{{n}}
				3.5、根据您与”武汉飞游云创新科技有限公司”签订的租赁协议，您可以通过”武汉飞游云创新科技有限公司”提供的产品，合法使用您自己的或您获得合法授权的产品和服务。但您声明和保证，不得以任何方式侵犯或企图侵犯”武汉飞游云创新科技有限公司”及其产品和服务、以及任意第三方的产品和服务；不会侵犯”武汉飞游云创新科技有限公司”或任意第三方的合法权益。{{n}}
				3.6、您声明并保证您使用”武汉飞游云创新科技有限公司”的产品和服务以及第三方产品和服务，和/或通过”武汉飞游云创新科技有限公司”的产品和服务进行非法活动，应遵循诚实信用原则，尊重社会公德，不损害社会公共利益。您应保证：{{n}}
				1） 您提供的前述身份信息无瑕疵或者造假，并有义务及时进行更新因身份信息更替的有效证件。如因您提供的虚假身份信息导致我公司及其他第三方损失的，您应承担全部责任。{{n}}
				2） 您不得损害”武汉飞游云创新科技有限公司”和他人的合法权益，不得妨碍”武汉飞游云创新科技有限公司”和第三方行使权益，例如不给其他任何第三方带来损害，妨碍第三方权益或给我公司的产品和服务造成损失。{{n}}
				3） 不得买卖、抵押、质押、转租设备，不得擅自变动、修理、拆卸、更改租赁设备硬件及任何部件{{n}}
				3.7、您明确理解并同意，您通过”武汉飞游云创新科技有限公司”的产品和服务和同时使用第三方的产品和服务时，不会损害我方产品的安全性和完整性。您应与第三方单独签署相应的《使用协议》，并严格按照协议的约定履行。如因您使用第三方的产品和服务引发的任何纠纷，您应自行承担由此引发的全部责任。”武汉飞游云创新科技有限公司”对此不承担任何责任。如因您使用第三方产品损害我公司产品的，您需承担损害赔偿责任。
			</div>
			<div class="subTitle">四、支付及续租</div>
			<div class="textContent">
				4.1、”武汉飞游云创新科技有限公司”提供的产品和服务包含收费内容和/或免费内容。您同意为您使用的收费产品和服务付款，且”武汉飞游云创新科技有限公司”有权就您租赁的任何产品和享有的服务向您收取相关的费用，该费用为一次性收取。{{n}}
				4.2、您支付的款项将用于租赁”武汉飞游云创新科技有限公司”的收费内容，您应仔细阅读该内容的用户条款并自行决定购买与否。除非双方另有约定，一旦支付成功，交易即完成。当或仅当，”武汉飞游云创新科技有限公司”终止该付费内容的服务，您可以申请退还尚未使用的款项或以此为基础更换”武汉飞游云创新科技有限公司”的其他产品和服务。{{n}}
				4.3、”武汉飞游云创新科技有限公司”的收费政策可能随时变化，如出现降价或促销等情形，”武汉飞游云创新科技有限公司”概不退款。{{n}}
				4.4、”武汉飞游云创新科技有限公司”不认可通过”武汉飞游云创新科技有限公司”指定对的支付平台之外的线上线下交易所产生的交易行为，您通过”武汉飞游云创新科技有限公司”指定的支付平台之外的交易行为所获得的产品和服务将被认定为来源不符合”武汉飞游云创新科技有限公司”的规则。{{n}}
				4.5、经相关政府部门或司法机关核实的违法交易，利害关系人可向”武汉飞游云创新科技有限公司”提出申请，”武汉飞游云创新科技有限公司”将及时采取措施终止交易服务并在一年内保存有关记录。{{n}}
				4.6、您需要根据租赁的不同产品和服务支付相应的租金，费用包括租金和押金； 平台提供支付宝、信用卡、芝麻信用授权等支付方式。{{n}}
				4.6.1 产品租金及押金由商家自主确定，租户在下单时，由平台代收相应租金、押金。{{n}}
				4.6.2 平台根据租户信用资质授予免押金额度，设备押金在免押金额度范围内的，不需要支付押金，超出部分，应支付押金。租赁期限届满，租户应及时将设备归还商家，商家在收到设备后经检测确认无损坏的，应当在3个工作日退还押金，节假日顺延。
				租户在租赁期限届满后未及时归还设备的，商家除有权继续按协议约定标准收取租金外还可按 元/天收取违约金；租户逾期归还设备超过15天的，商家可直接向平台申请扣除租户全部押金。{{n}}
				4.6.3 平台提供了租金按月支付和按季度支付两种方式，租户的首付租金应当在下单时支付。平台在下一个交租周期自动从租户的注册账户中扣除下月租金。租户应保证在租金付款日账户中有足够金额，以免造成租金支付逾期。{{n}}
				4.6.4 租户应当按时足额支付租金，否则，商家有权提前终止本协议，收回租赁设备，并要求租户付清所欠的租金并加收租金总额30%的违约金。{{n}}
				4.6.5租期期间正常设备折旧，设备自然产生的硬件故障由商家免费更换，软件问题由商家协助。因人为损坏，拆解，划痕等问题导致维修的，租户应承担配件成本和维修费用，维修期间的租期费用继续计算。如设备无法修复或修复价格远远超过设备本身价值或设备丢失的，租户应当按下单页中约定的设备单价格进行原价赔偿。{{n}}
				4.7、租赁期限届满后，租户需要续租的，可以申请续租即在“我的订单”找到待归还的设备，点击续租按钮，商户同意后，租户继续按原租赁协议约定标准及期限支付租金，无需另行支付押金。当租户逾期不缴纳租金时，租户有权收回租赁设备、终止履行协议并要求租户承担相应的违约责任。{{n}}
				4.8、发货后非设备质量问题，恕不退货。 租期自商家快递派单（寄出）当天起算或商家上门送货安装当天起算至设备归还商家并检测合格之日止。除非商家设备介绍页面约定可随借随还，否则租户不能提前归还，按原租期计算租金，已交租金不退。{{n}}
				4.9、订单支付成功后，平台对租户订单信息进行评估，若平台判定租户风险系数较高，平台有权让租户补交押金或授权，订单未补交押金或担保物的，将直接关闭，已经支付的款项原路退还租户。发票由商家提供，默认设备租金不含税，租户需开取发票的，下单时候，索取发票，填写发票抬头，以及开票详细资料。开票内容可为“租赁服务费”，类型可以为增值税普通发票或增值税专用票，每一个产品详情都标注开发票类型。{{n}}
			</div>
			<div class="subTitle">五、违约和赔偿</div>
			<div class="textContent">
				5.1、如您认为其他用户或任意第三方损害了您的合法权益，您可以通知”武汉飞游云创新科技有限公司”进行投诉或反映。但如您未能提交充分的证据证明您的要求，或在”武汉飞游云创新科技有限公司”要求您修改请求或补充证据后2个工作日内，未回复或未能补充提交符合要求的证据。”武汉飞游云创新科技有限公司”将视情况不予受理。{{n}}
				5.2、如第三方对您非法使用租赁产品而通知”武汉飞游云创新科技有限公司”时，”武汉飞游云创新科技有限公司”有权根据第三方所提交的证据进行初步判断。如认为第三方要求合法，”武汉飞游云创新科技有限公司”会以您在下单时提供的有效联系方式联系您，以达到解决争议的方案。{{n}}
				5.3、您应遵守法律法规及其本协议的约定，否则被行政机关或第三方调查或举报，及或因此损害”武汉飞游云创新科技有限公司”及或第三方的权益的，您应当负责解决并承担全部法律责任；并且”武汉飞游云创新科技有限公司”有权随时在不通知您的前提下按照如下方案予以处理，而不承担任何责任：{{n}}
				1） 单方解除本协议；{{n}}
				2） 中/终止提供产品和服务；{{n}}
				3） 将您的行为对外予以公告；{{n}}
				4） 追究您的法律责任；{{n}}
				5） 其他”武汉飞游云创新科技有限公司”认为适合的处理措施。{{n}}
				5.4、如您损害”武汉飞游云创新科技有限公司”的合法权益，或您导致”武汉飞游云创新科技有限公司”遭受任何来自第三方的纠纷、诉讼、索赔要求等，您须向”武汉飞游云创新科技有限公司”赔偿相应的损失，并需对因您的行为产生的一切后果负全部法律责任。”武汉飞游云创新科技有限公司”有权从您与”武汉飞游云创新科技有限公司”的应付款若有）中直接予以抵扣。{{n}}
				5.5、您应使”武汉飞游云创新科技有限公司”及其董事和雇员，免于因任意第三方提起的索赔、仲裁或诉讼、行政处罚，包括但不限于和解、出庭、承担由此给前述单位和人员及/或任何第三方造成的一切责任、损失和赔偿，包括但不限于诉讼费用、律师费用、和解费用、罚款或生效法律文书中规定的损害赔偿金额。{{n}}
				5.6、以下情况之一的，租户将被认定为失信客户：{{n}}
				（1）逾期1个月不支付设备租金的或逾期后不缴纳逾期租金的。{{n}}
				（2）租赁期满，但拒不归还的。{{n}}
				（3）归还的设备严重损坏，但拒不偿付维修费用的。{{n}}
				租户同意，对于失信租户，平台及商家将有权利采取包括但不限于以下的措施：{{n}}
				（1）将失信租户公司信息及相应负责人个人信息在人人租机网站公布。{{n}}
				（2）有权将违约信息反馈给依法设立的征信机构（包括但不限于芝麻信用管理有限公司），租户了解上述违约信息可能影响租户在征信机构处的信用状况，并可能影响其申请或办理相关服务。{{n}}
				（3）向公安机关报案。{{n}}
				（4）向法院起诉，并依照相关法律规定，报请将失信租户的身份信息及相关公司信息至中国人民共和国全国法院被执行人信息网公布。{{n}}
			</div>
			<div class="subTitle">六、数据、信息和隐私权保护</div>
			<div class="textContent">
				本协议所指的“隐私”包括《电信和互联网用户个人信息保护规定》第4条规定的用户个人信息的内容以及未来不时制定或修订的法律法规中明确规定的隐私应包括的内容。{{n}}
				6.1当用户注册人人租机以及在使用平台租赁服务时，用户须向提供个人信息。人人租机收集个人信息的目的是为用户提供尽可能多的个人服务以及风险评估，从而用户提供免押租赁服务，在此过程中，平台不会泄露个人信息。{{n}}
				6.2人人租机不会在未经合法用户授权时，公开、编辑或透露其个人信息及保存在人人租机中的非公开内容，除非有下列情况：{{n}}
				（1）事先获得用户的明确授权；{{n}}
				（2）根据有关的法律法规要求；{{n}}
				（3）按照相关政府主管部门的要求；{{n}}
				（4）为维护社会公众的利益；{{n}}
				（5）用户已成为严重失信用户；{{n}}
				6.3为提升服务的质量，人人租机可能会与第三方合作共同向用户提供相关服务，此类合作可能需要包括但不限于用户数据与第三方用户数据的互通。在此情况下，用户知晓并同意如该第三方同意承担与人人租机同等的保护用户隐私的责任，则人人租机有权将用户的注册资料等提供给该第三方，并与第三方约定用户数据仅为双方合作之目的使用；并且人人租机将对该等第三方使用用户数据的行为进行监督和管理，尽一切合理努力保护用户个人信息的安全性。{{n}}
				6.4人人租机可以向用户注册的电子邮箱、手机号码发送服务所必须的商业信息。{{n}}
			</div>
			<div class="subTitle">七、服务中止或终止</div>
			<div class="textContent">
				7.1、下述任一原因发生，无需提前通知，”武汉飞游云创新科技有限公司”有权单方面决定是否随时中止或终止服务，您同意并接受”武汉飞游云创新科技有限公司”的处理决定：{{n}}
				1） 您或您授权的第三方向”武汉飞游云创新科技有限公司”申请中止或终止服务；{{n}}
				2） 因不可抗力原因，服务中止或终止；{{n}}
				3） “武汉飞游云创新科技有限公司”无法预见和控制的原因，租赁中止或终止；{{n}}
				4） “武汉飞游云创新科技有限公司”认为实际情形不再适宜继续履行本协议；{{n}}
				5）租赁期满，乙方归还设备，经商家检测并结清所有费用后，该协议终止；如乙方下单后设备交付前取消订单，经商家与租户协商一致，该协议终止。{{n}}
				6） 本协议约定的其他情况。{{n}}
				7.2、不论”武汉飞游云创新科技有限公司”与您之间的租赁服务因任何原因以任何方式终止，您同意并接受：{{n}}
				1） “武汉飞游云创新科技有限公司”有权保存或不保存您租赁的产品和服务及其他相关数据和信息；{{n}}
				2） “武汉飞游云创新科技有限公司”有权保存或不保存您的个人信息；{{n}}
				7.3、如无论因任何原因终止的，在终止之前，您应自行处理好使用租赁产品获得的数据、信息的备份以及与”武汉飞游云创新科技有限公司”、任意第三方间的相关事项的处理等，否则，由此产生的您与任意第三方之间的纠纷等问题由您自行负责解决，并单独承担完全责任。{{n}}
				7.4、您必须完全独立地承担，您在服务终止前实施的违法或违约行为所导致的任何赔偿和责任。{{n}}
				7.5、”武汉飞游云创新科技有限公司”未行使本协议的任何权利或规定，不构成对前述权利之放弃。{{n}}
			</div>
			<div class="subTitle">八、不可抗力</div>
			<div class="textContent">
				8.1、不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、法规政策颁布和修改、行政行为、政府决定等。{{n}}
				8.2、出现上述情况时，”武汉飞游云创新科技有限公司”将努力在第一时间与相关单位配合，及时进行修复，若由此给您造成损失的，您同意放弃追究”武汉飞游云创新科技有限公司”的责任。{{n}}
			</div>
			<div class="subTitle">九、免责事项</div>
			<div class="textContent">
				9.1、”武汉飞游云创新科技有限公司”不因下述任一情况而可能导致的任何损害赔偿承担责任，包括但不限于财产、收益、数据资料等方面的损失或其它无形损失：{{n}}
				1） 因不可抗力导致”武汉飞游云创新科技有限公司”系统障碍不能正常运作；{{n}}
				2） 由于黑客攻击、电信部门技术调整或故障、系统维护等原因而造成的平台服务中断或者延迟。{{n}}
				9.2、鉴于租赁服务的特殊性，”武汉飞游云创新科技有限公司”有权在无需通知您的情况下根据”武汉飞游云创新科技有限公司”及其关联企业的整体运营情况或相关运营规范、规则等，提前终止租赁服务。若由此给您造成损失的，您同意放弃追究”武汉飞游云创新科技有限公司”的责任。对于此类情形下可能造成的风险，请您充分了解并同意自行承担由此可能造成的一切不利后果和损失。{{n}}
				9.3、”武汉飞游云创新科技有限公司”不保证产品和服务能符合所有用户的使用要求；同时，”武汉飞游云创新科技有限公司”不保证您所有的数据和信息、产品和服务以及隐私信息都永久地、完整地保存在”武汉飞游云创新科技有限公司”的服务器中。对于此类情形下可能造成的风险，请您充分了解并同意自行承担由此可能造成的一切不利后果和损失。{{n}}
				9.4、在法律允许的最大限度内，”武汉飞游云创新科技有限公司”明确表示不对其产品和服务做出任何明示、暗示和强制的担保。{{n}}
				9.5、”武汉飞游云创新科技有限公司”的产品经过”武汉飞游云创新科技有限公司”详细的测试，但”武汉飞游云创新科技有限公司”不能保证其与能满足未知领域的同样适用情形。如果出现不适用的情况，您可向”武汉飞游云创新科技有限公司”反馈以获得技术支持。{{n}}
			</div>
			<div class="subTitle">十、协议的解释和变更</div>
			<div class="textContent">
				在法律允许的范围内，”武汉飞游云创新科技有限公司”保留对本协议任何条款的解释权和随时变更的权利。”武汉飞游云创新科技有限公司”可能会随时根据需要修改本协议的任一条款。如发生此类变更，”武汉飞游云创新科技有限公司”会提供更新后的协议并在相关网页上进行提示和说明。更新后的协议自公布之日起生效。
			</div>
			<div class="subTitle">十一、协议完整性和相互关系</div>
			<div class="textContent">
				11.1、本协议部分条款的无效，不影响其他条款的有效性和可履行性。{{n}}
				11.2、您和”武汉飞游云创新科技有限公司”均是独立的主体，在任何情况下本协议不构成双方之间的代理、合伙、合营或雇佣关系。{{n}}
				11.3、您声明并同意”武汉飞游云创新科技有限公司”可指定第三方成为本协议的受益人，并有权直接履行和享受本协议项下权利。{{n}}
				11.4、下单页面、商家发货单等均是本协议附件，与本协议有同等法律效力。{{n}}
				11.5、本协议有效期自乙方下单并依约支付租金日起至商家收回设备检测合格且乙方结清所有租金等费用之日止。{{n}}
			</div>
			<div class="subTitle">十二、通知和送达</div>
			<div class="textContent">
				12.1、如果您在使用”武汉飞游云创新科技有限公司”的产品和服务过程中有任何意见或建议，您可通过意见反馈渠道提出，”武汉飞游云创新科技有限公司”将向您及时作出反馈。您应保证您的联系方式畅通，以接收来自”武汉飞游云创新科技有限公司”发出的邮件、电话或信息。”武汉飞游云创新科技有限公司”不对您未收到通知而引起的任何损失承担责任。{{n}}
				12.2、 “武汉飞游云创新科技有限公司”向您发出的通知，采用电子邮件或页面公告的方式；该等通知于发送/公告之日视为已送达收件人。{{n}}
				12.3、您可以按照”武汉飞游云创新科技有限公司”所公布的：{{n}}
				地址：武汉东湖新技术开发区关山大道1号光谷软件园4.2期研发楼E4栋（自贸区武汉片区）{{n}}
				联系电话：15071184576{{n}}
				电子邮件地址：985751468@qq.com{{n}}
				任一联系方式向”武汉飞游云创新科技有限公司”发出通知，”武汉飞游云创新科技有限公司”收到之日起视为已送达。
			</div>
			<div class="subTitle">十三、法律适用与司法管辖</div>
			<div class="textContent">
				本协议及因本协议产生的一切法律关系及纠纷，均适用中华人民共和国法律。双方在此同意由武汉飞游云创新科技有限公司所在地人民法院管辖。
			</div>
		</div>
	</div>
</template>

<script>
export default {
    data(){
        return {
				n:'\n'
			}
    }
}
</script>

<style>
.pageContainer {
  font-size: 14px;
  padding: 12px;
}
.textHeader{
  text-align: center;
  font-weight: bold;
  font-size: 18px;
}
.subTitle {
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
}
.textContent {
  margin-top: 7px;
  font-size: 14px;
  white-space: pre-line;
}
</style>


// WEBPACK FOOTER //
// src/pages/protocal.vue